import React from 'react';
import { ThingsToDoSection } from '../components/ThingsToDoSection';
import { FAQSection } from '../containers/FAQSection';
import { HeroSection, HeroSectionProps } from '../containers/HeroSection/';
import { NearbyCities, NearbyCitiesProps } from '../containers/NearbyCities/';
import {
    Breadcrumb,
    ThingsToDoBreadcrumbs,
} from '../containers/ThingsToDoBreadcrumbs';
import { TopActivities, TopActivitiesProps } from '../containers/TopActivities';
import {
    TrendingSearches,
    TrendingSearchesProps,
} from '../containers/TrendingSearches';
import {
    CollectionShape,
    UniqueExperiences,
} from '../containers/UniqueExperiences';
import { Category, WaysToTour } from '../containers/WaysToTour';

import { Organizer } from '../components/OrganizersSection/utils';
import { TopOrganizers } from '../containers/TopOrganizers';

interface ThingsToDoProps {
    breadcrumbs: Breadcrumb[];
    trendingSearchesResult: TrendingSearchesProps;
    topEventsData: TopActivitiesProps;
    nearbyCitiesResult?: NearbyCitiesProps;
    topOrganizers: Organizer[];
    categories?: Category[];
    heroSection: HeroSectionProps;
    editorialCollections: CollectionShape[];
}

export const ThingsToDoPage: React.FunctionComponent<ThingsToDoProps> = (
    props,
) => {
    return (
        <>
            <ThingsToDoBreadcrumbs breadcrumbs={props.breadcrumbs} />
            <HeroSection
                placeImage={props.heroSection.placeImage}
                isPageArt={props.heroSection.isPageArt}
                artistName={props.heroSection.artistName}
                artistInstagramLink={props.heroSection.artistInstagramLink}
            />
            <TopActivities {...props.topEventsData} />
            <WaysToTour categories={props.categories} />
            <UniqueExperiences
                editorialCollections={props.editorialCollections}
            />
            {props.topOrganizers?.length ? (
                <TopOrganizers topOrganizers={props.topOrganizers} />
            ) : (
                <></>
            )}
            <TrendingSearches {...props.trendingSearchesResult} />
            {props.nearbyCitiesResult ? (
                <ThingsToDoSection>
                    <NearbyCities places={props.nearbyCitiesResult.places} />
                </ThingsToDoSection>
            ) : (
                <></>
            )}
            <FAQSection
                topEventsBucket={props.topEventsData.top_events || []}
                topOrganizersBucket={props?.topOrganizers || []}
                nearbyCitiesBucket={props.nearbyCitiesResult?.places || []}
                trendingSearchesBucket={
                    props.trendingSearchesResult.trending || []
                }
            />
        </>
    );
};
